import React, { useState, useEffect, useRef } from 'react';
import LoaderComponent from "../../../libraries/loader/loader";
import { Fetchexecutequery,getvendorcode,Fetchbankinvoicedetails1,Fetchexternaldetails, getProcessingLayerDataFromServer, getProcessingLayerDataWithStatusFromServer, getUpdateMatchRecordsFromServer, getUpdateUnMatchRecordsFromServer, getUpdateDuplicateRecordsFromServer, getUpdateContraRecordsFromServer, getProcessingLayerDataReturnFromServer, getUpdateGlBalFromServer, getUpdateBankBalFromServer, Fetchbankinvoicedetails,Fetchbankinvoicedetails_1, Fetchmatchedutrdata, Fetchmatchedutrdata1, updatestatusvalue, allocateupdatestatusvalue, fetchmonthwisedata1, getdonutseriesdata, getkpidatarecon, getpaymenthistory, getstatustypeslist, getremarksdata, fetchmonthwisedatanew, getpaymenthistorynew, getdataforcardsrecon } from '../../../services/process/BRS1/brsService1';
import { send_emails,send_emails1, port, Fetchunreademails1, run_matchingrule, fetchmailloginfo1 } from '../../../services/process/process_data1/process_data';
import { Input, Button } from 'semantic-ui-react';
import axios from "axios";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import { AgGridReact } from 'ag-grid-react';
import Select, { AriaOnFocus } from 'react-select';
import { baseUrl } from "../../../services/common/credentials";

const localhost_url = baseUrl + port;

const gridColumnDefs = [
    {field: 'received_time', headerName: 'received_time', sortable: true, filter: true, resizable: true, width: 130},
    {field: 'subject', headerName: 'subject', sortable: true, filter: true, resizable: true, width: 150},
    {field: 'mail_read_time', headerName: 'mail_read_time', sortable: true, filter: true, resizable: true, width: 100},
    
]

function EmailsListSendRead() {
    const [loaderOpen, setLoaderOpen] = useState(false);
    const [setoptions, setOptions] = useState({});
    const [setoptions1, setOptions1] = useState({});
    const [setoptions4, setOptions4] = useState({});
    const [setoptions2, setOptions2] = useState({});
    const [options4, setVendorname] = useState({});
    const [options2, setdivisionname] = useState({});
    const [options3, setdivisionnames] = useState({});
    const [options1, setVendorcode] = useState({});
    const [gridColumns, setGridColumns] = useState([]);
    const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));

    const Options = [
        { value: "1", label: "Monthly" },
        { value: "2", label: "Quaterly" },
        { value: "3", label: "Half Yearly" },
        { value: "4", label: "Annual" },
    ];

    // const [columnDefs] = useState(gridColumnDefs);
    const [rowData, setRowData] = useState(undefined);
    const customStyles = {
        control: base => ({
            ...base,
            height: 35,
            minHeight: 35,
            marginTop: 0,
            paddingTop: -5,
            fontSize: 14,

        })
    };


    function sendemails() {
        setLoaderOpen(true);
        let payload = {

            'frequency_id': setoptions,
            'vendor_code': setoptions1,
            'division':setoptions2
            
        }
        console.log('payload', payload);
	if (setoptions1 === "") {
           console.log("hii");
           var getSingleMailSent = send_emails1();
        } else {
           console.log("test");
           var getSingleMailSent = send_emails();
        }


        

        axios.post(getSingleMailSent[1], JSON.stringify(payload), getSingleMailSent[0])
            .then(
                response => {
                    console.log("Mail Sent Response!!!", response)
                    let data = response["data"];
                    if (response["status"] === 200) {
                        alert("Mail Sent Successfully!!!");

                    }
                    else{
                        alert("Error in mail sending!!!");

                    }
                    setLoaderOpen(false);
                }
            ).catch(
                error => {
                    console.log("Error in emails Upload List!!!", error);
                    setLoaderOpen(false);

                }
            );
    }

    function get_report() {
        setLoaderOpen(true);
        let payload = {
            // "type": options.value,
            'entities_id': userCredentials["entities_id"],
            'tenants_id': userCredentials["tenants_id"],
            'groups_id': userCredentials["groups_id"],
            
            
        }
        console.log('payload', payload,userCredentials);

        var getSingleMailSent = Fetchunreademails1();

        axios.post(getSingleMailSent[1], payload, getSingleMailSent[0])
            .then(
                response => {
                    console.log("fetch processed emails list", response)
                    let data = response["data"];
                    console.log('data', data);
                    setLoaderOpen(false);
                }
            ).catch(
                error => {
                    console.log("Error in Fetching processed emails list", error);
                    setLoaderOpen(false);
                }
            );
    }

    function run_matching_rule() {
        setLoaderOpen(true);
        let payload = {
            
            'user_id': userCredentials["user_id"],
        }
        console.log('payload123', payload);

        var getSingleMailSent = run_matchingrule();

        axios.post(getSingleMailSent[1], payload, getSingleMailSent[0])
            .then(
                response => {
                    console.log("fetch processed emails list", response)
                  
                    setLoaderOpen(false);
                }
            ).catch(
                error => {
                    console.log("Error in Fetching processed emails list", error);
                    setLoaderOpen(false);
                }
            );
    }

    function handleChange1(data) {
        setOptions(data);
        BrsTypeList();
        setOptions1('');
        setOptions2('')
    }


    function handleChange2(data) {
        setOptions2(data);
        setOptions1('');
	let divisionname = data.label
        let payload = {
          query:` select distinct vendor_code,vendor_name  from Vendor_Reconcilation_System.vendor_master where division = '${divisionname}';`}

        var getProcessingLayerList = Fetchexecutequery();
    
        axios.post(getProcessingLayerList[1], payload, getProcessingLayerList[0])
          .then(
            response => {
              console.log("Processing customer List vendor code!!!", response)
              
              let data = response["data"];
              
              console.log('data', data);
              if (data) {
                let vendorcode = data.map((row) => ({label:row.vendor_code, value:row.vendor_code,name:row.vendor_name}));
                let vendorname = data.map((row) => ({label:row.vendor_name, value:row.vendor_code}));
                setVendorname(vendorname);
                setVendorcode(vendorcode);
              }
              setLoaderOpen(false);
            }
          ).catch(
            error => {
              console.log("Error in Processing Layer List!!!", error);
              setLoaderOpen(false);
            }
          );   
    }

    function sendemail(data) {
        sendemails()
        BrsTypeList();
        setOptions1('');
        setOptions2('');

    }

    const filterOptions = (options4, selectedOption) => {
        // Implement your filtering logic here
        // Example filtering logic based on selectedOption value
        if (!selectedOption) {
            return options4; // Return all options if selectedOption is null or undefined
        } else {
            const filteredOptions = options4.filter(option => option.value === selectedOption.value); // Example filtering based on a property match
            return filteredOptions;
        }
    };

    function handleChange3(data) {
        setOptions1(data);
	const filteredOptions4 = filterOptions(options4, data); // Implement your filtering logic
        setOptions4(filteredOptions4);
    }

    function handleChange4(data) {
        setOptions4(data);
	const filteredOptions4 = filterOptions(options1, data); // Implement your filtering logic
        setOptions1(filteredOptions4);

    }

    function BrsTypeList() {
        setLoaderOpen(true);
        let payload = {
          query:`select distinct division from Vendor_Reconcilation_System.vendor_master;`}
        console.log('userCredentials["groups_id"],', userCredentials);
        var getProcessingLayerList = Fetchexecutequery();
    
        axios.post(getProcessingLayerList[1], payload, getProcessingLayerList[0])
          .then(
            response => {
              console.log("Processing customer List vendor code!!!", response)
              
              let data = response["data"];
              
              console.log('data', data);
              if (data) {
                let client_ids = data.map((row) => ({label:row.division, value:row.division}));
                setdivisionname(client_ids);
                console.log('data', client_ids);
              }
              setLoaderOpen(false);
            }
          ).catch(
            error => {
              console.log("Error in Processing Layer List!!!", error);
              setLoaderOpen(false);
            }
          );
    
      }

    const intColumnDefs = React.useMemo(() => {
        if (rowData?.length > 0) {
          // Get the column names from the first row of the JSON data
          const keys = Object.keys(rowData[0]);
      
          // Create column definitions with the checkbox as the first column
          const intColumnDefs = [
            
            ...keys.map((key) => ({
              headerName: key,
              field: key,
              sortable: true, 
              filter: true, 
              resizable: true,
              width: 100
            })),
          ];
          setGridColumns(intColumnDefs);
          console.log('intColumnDefs', intColumnDefs);
          return intColumnDefs;
        }
        return [];
      }, [rowData]);

    const fetchreadmailinfo = () => {

        let payload = {
            File_data: 'test',
          }
      
          var FileUploadCredentials = fetchmailloginfo1();
      
          axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
            .then(
              response => {
                console.log("Validate Credentials Response!!!", response);
                let data = response.data;
                
                setRowData(data)
              }
            ).catch(
              error => {
                console.log("Error", error);
                alert("Error in fetch mail info!!!");
              }
            );
    }



 

    useEffect(() => {
        fetchreadmailinfo(); 
    },[]);


    return (
        <>
            <div className="side" style={{ padding: "10px", marginLeft: '10px' }}>

                <div className='row' style={{ backgroundColor: "#fff", borderRadius: "12px", marginTop: "10px" }}>

                    <div className='col-md-2 pt-2 pb-2'>
                        <label htmlFor="underline_select " style={{ fontSize: '15px', paddingBottom: '0.3em' }}> Frequency</label>
                        <Select
                            options={Options}
                            placeholder="Frequency"
                            value={setoptions}
                            onChange={handleChange1}
                            isSearchable={true}
                            styles={customStyles}
                        />
                    </div>

                    <div className='col-md-2 pt-2 pb-2'>
                        <label htmlFor="underline_select " style={{ fontSize: '15px', paddingBottom: '0.3em' }}> Division</label>
                        <Select
                            options={options2}
                            placeholder="Division"
                            value={setoptions2}
                            onChange={handleChange2}
                            isSearchable={true}
                            styles={customStyles}
                        />
                    </div>


                    <div className='col-md-2 pt-2 pb-2'>
                        <label htmlFor="underline_select " style={{ fontSize: '15px', paddingBottom: '0.3em' }}> Vendor Code</label>
                        <Select
                            options={options1}
                            placeholder="Vendor Code"
                            value={setoptions1}
                            onChange={handleChange3}
                            isSearchable={true}
                            styles={customStyles}
                        />
                    </div>
                    <div className='col-md-2 pt-2 pb-2'>
                        <label htmlFor="underline_select " style={{ fontSize: '15px', paddingBottom: '0.3em' }}> Vendor Name</label>
                        <Select
                            options={options4}
                            placeholder="Vendor Code"
                            value={setoptions4}
                            onChange={handleChange4}
                            isSearchable={true}
                            styles={customStyles}
                        />
                    </div>
                   <div className='col-md-2 pt-2 pb-2'>
                        <Button className='mt-4'  variant="contained" color="primary" type="button" onClick={sendemail}>Send Email</Button>
                    </div>
                    <div className='col-md-2 pt-2 pb-2' >
                        <Button className='mt-4'  variant="contained" color="primary" type="button" onClick={get_report}> Read Email</Button>
                    </div>
                    
                    {/* <div className='col-md-2 pt-2 pb-2' >
                        <Button className='mt-4' variant="contained" color="primary" type="button" onClick={run_matching_rule}>Run</Button>
                    </div> */}
                </div>
            </div>
            {/* <div className="report" >
                
                <div className="ag-theme-balham report-layer" style={{width:'100%', heidght:'100%'}}>
                    <AgGridReact
                        columnDefs={gridColumns}
                        rowData={rowData}
                        paginationPageSize={15}
                        pagination={true}
                        animateRows={true}
                        rowSelection={'multiple'}
                        groupSelectsChildren={true}
                        // ref={gridRef}
                        suppressAggAtRootLevel={true}
                        suppressRowClickSelection={true}
                        
                    >
                    </AgGridReact>
                </div>
            </div> */}
          
            <LoaderComponent loaderOpen={loaderOpen} />
        </>
    );
}


export default EmailsListSendRead;

